module.exports = __webpack_public_path__ + "assets/images/coin-5-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-5-on.png
// module id = 1506
// module chunks = 1